import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-yumemofumofu')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  if (document.getElementById('mofPro')) {
    // Swiperコンテナを検出したら実行
    // eslint-disable-next-line no-unused-vars

    const sliderName = 'mofPro'
    const slideItem = document.getElementById(sliderName)

    // 各要素を取得
    const slideWrap = slideItem.querySelector('.swiper-wrapper')
    const slideList = slideItem.querySelectorAll('.swiper-slide')
    let slideCount = slideList.length // スライドの数

    const slidePerViewMax = 0 * 3 // ループ表示に必要なスライド数　slidesPerViewの2倍
    // ループに不足するスライドを補充する
    while (slideCount < slidePerViewMax) {
      for (const iterator of slideList) {
        const clone = iterator.cloneNode(true)
        slideWrap.appendChild(clone)
        ++slideCount
      }
    }

    const mofProSwiper = new Swiper(slideItem, {
      // init: false, // 自動で初期化しない（mofProSwiper.init()で初期化）
      effect: 'fade', // slide,fade,cube,coverflow
      speed: 300, // アニメ速度
      loop: true, // ループ
      preloadImages: false, // スライド内の画像を読み終えてから開始
      touchRatio: 0, // タッチスワイプ感度（0でタッチスワイプ無効）
      fadeEffect: {
        // フェードオプション
        crossFade: true, // クロスフェード
      },

      navigation: {
        nextEl: '.swiper-button-next--' + sliderName, // 前のページボタンを呼び出す要素
        prevEl: '.swiper-button-prev--' + sliderName, // 次のページボタンを呼び出す要素
      },
    })
  }
}
